import React from "react";
import { Checkbox } from "@mui/material";
import styles from "./tableCheckBox.module.scss";

import { ReactComponent as CheckBoxTickIcon } from "../../assets/icons/TypeChecked.svg";
import { ReactComponent as CheckBoxUncheckIcon } from "../../assets/icons/TypeDefault.svg";
import { ReactComponent as CheckBoxPartialIcon } from "../../assets/icons/TypePartial.svg";

const TableCheckBox = (props) => {

  return (
    <Checkbox
      icon={<CheckBoxUncheckIcon className={styles.unChekcedIcon} />}
      checkedIcon={<CheckBoxTickIcon className={styles.checkedIcon} />}
      indeterminateIcon={<CheckBoxPartialIcon className={styles.checkedIcon} />}
      {...props}
      data-testid='table-checkbox'
    />
  );
};
export default TableCheckBox;
